import { useQueryDataTableFilter } from '~/shared/data-tables/query/useQueryDataTableFilter';
import { CheckboxField } from '~/shared/forms/controls/base-fields/CheckboxField';
import { NumberField } from '~/shared/forms/controls/base-fields/NumberField';

type ThresholdType = 'under' | 'over';
type Thresholds = Record<ThresholdType, number | null>;

const thresholdOptions: Record<ThresholdType, { label: string; fieldLabel: string; defaultValue: number }> = {
	under: { label: 'Under', fieldLabel: 'Under Utilized Total', defaultValue: 25 },
	over: { label: 'Over', fieldLabel: 'Over Utilized Total', defaultValue: 35 }
};

function parseThresholds(value: string | null): Thresholds {
	const entries = (value ?? '').split('|').map(x => x.split(':'));
	const find = (type: ThresholdType) => {
		const threshold = Number(entries.find(x => x[0] === type)?.[1]);
		return Number.isNaN(threshold) ? null : threshold;
	};
	return { under: find('under'), over: find('over') };
}

function serializeThresholds(thresholds: Thresholds) {
	const values = (Object.keys(thresholdOptions) as ThresholdType[]).filter(x => thresholds[x] !== null).map(x => `${x}:${thresholds[x]}`);
	return values.length > 0 ? values.join('|') : null;
}

export function GallagherEmployeesFilter() {
	const [gallagherEmployees, setGallagherEmployees] = useQueryDataTableFilter<boolean>({
		name: 'isGallagherEmployee',
		convertFromQueryParam: value => value === 'true'
	});
	return <CheckboxField label="Gallagher Employees" hideLabel value={gallagherEmployees} onChange={x => setGallagherEmployees(x || null)} />;
}

export function UtilizationThresholdFilter({ type }: { type: ThresholdType }) {
	const [utilization, setUtilization] = useQueryDataTableFilter({ name: 'utilization' });
	const thresholds = parseThresholds(utilization);
	const { label, fieldLabel, defaultValue } = thresholdOptions[type];
	const threshold = thresholds[type];
	const setThreshold = (value: number | null) => setUtilization(serializeThresholds({ ...thresholds, [type]: value }));

	return (
		<>
			<CheckboxField label={label} hideLabel value={threshold !== null} onChange={x => setThreshold(x ? defaultValue : null)} />
			{threshold !== null && (
				<NumberField
					className="w-[110px]"
					label={fieldLabel}
					hideLabel
					minValue={0}
					value={threshold}
					onChange={x => setThreshold(Number.isNaN(x) ? defaultValue : x)}
				/>
			)}
		</>
	);
}
